import { useState } from "react";
import { Image, Row, Col, Button, Form } from "react-bootstrap";
import useWindowDimensions from "../../utils/useWindowDimensions";


// import Balloon from '../../assets/airballoon.png'
import Logo from "../../assets/logos/Logo_Red.png"
import Twitter from "../../assets/logos/twitter.png"
import Telegram from "../../assets/logos/telegram.png"
import Medium from "../../assets/logos/medium.png"
import Reddit from "../../assets/logos/reddit.png"
import Discord from "../../assets/logos/discord.png"

import styles from "./SubscribeFooter.module.css";

function SubscribeFooter() {
    const { height, width } = useWindowDimensions();
    const [email, setEmail] = useState("");
    function addSubscriber(event) {
        event.preventDefault();
        alert(email)
    }
    return (
        <Row className={styles.ContentContainer}>
            <Col className={width > 992 ? `d-flex justify-content-between align-items-end` : ``}>
                <div className={styles.subscribeTextBlock}>
                    <div className={styles.subscribeTitle}>Subscribe to Our Newsletter</div>
                    <div className={styles.subscribeSubtext}>A monthly digest of the latest Voton news, articles, and resources.</div>
                </div>
                {width > 992 ?
                    <div className={styles.form}>
                        <Form>
                            <Form.Group className="d-flex flex-row">
                                <Form.Control
                                    type="email"
                                    size="lg"
                                    placeholder="Enter your email"
                                    autoComplete="subscriber"
                                    className={styles.subcriberEmailField}
                                    onChange={(text) => setEmail(text.target.value)}
                                />
                                <Button className={styles.submitButton} value="submit" type="submit" onClick={(e) => addSubscriber(e)}>
                                    <div className={styles.submitButtonText}>Submit</div>
                                </Button>
                            </Form.Group>
                        </Form>
                    </div>
                    : <></>}
            </Col>
            {width < 992 ?
                <div className={`${styles.form} d-flex align-items-center justify-content-center`}>
                    <Form>
                        <Form.Group className="d-flex flex-row">
                            <Form.Control
                                type="email"
                                size="lg"
                                placeholder="Enter your email"
                                autoComplete="subscriber"
                                className={styles.subcriberEmailField}
                                onChange={(text) => setEmail(text.target.value)}
                            />
                            <Button className={styles.submitButton} value="submit" type="submit" onClick={(e) => addSubscriber(e)}>
                                <div className={styles.submitButtonText}>Submit</div>
                            </Button>
                        </Form.Group>
                    </Form>
                </div>
                : <></>}
            {width < 768 ?
                <Row>
                    <Col className="d-flex d-flex align-items-center">
                        <Image src={Logo} className={styles.logo}></Image>
                        <div className={styles.socialIconCollection}>
                            <Image src={Twitter} className={styles.socialIcons}></Image>
                            <Image src={Telegram} className={styles.socialIcons}></Image>
                            <Image src={Reddit} className={styles.socialIcons}></Image>
                            <Image src={Discord} className={styles.socialIcons}></Image>
                            <Image src={Medium} className={styles.socialIcons}></Image>
                        </div>
                    </Col>
                </Row>
                : <Row className={styles.socialRow}>
                    <Col className="d-flex justify-content-between align-items-end">
                        <Image src={Logo} className={styles.logo}></Image>
                        <div className={styles.socialIconCollection}>
                            <Image src={Twitter} className={styles.socialIcons}></Image>
                            <Image src={Telegram} className={styles.socialIcons}></Image>
                            <Image src={Reddit} className={styles.socialIcons}></Image>
                            <Image src={Discord} className={styles.socialIcons}></Image>
                            <Image src={Medium} className={styles.socialIcons}></Image>
                        </div>
                    </Col>
                </Row>}
        </Row>
    );
}

export default SubscribeFooter;